import calendarApi from '@/services/plataforma/calendar';

export default {
  getCategories({ commit }) {
    return calendarApi.getCategories()
      .then(response => {
        commit('SET_CATEGORIES', response.data);
        commit('SET_VISIBLE_CATEGORIES', response.data.filter(({ canView }) => canView));
        commit('SET_CREATABLE_CATEGORIES', response.data.filter(({ canCreate }) => canCreate));
        Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response));
  },
  getCategoryById({ state }, id) {
    return state.categories.find(category => category.id === id);
  },
  getAppointments(_, params) {
    return calendarApi.getAppointments(params)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  getAppointmentById(_, id) {
    return calendarApi.getAppointmentById(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  createAppointment(_, data) {
    return calendarApi.createAppointment(data)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  editAppointment(_, data) {
    return calendarApi.editAppointment(data)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  deleteAppointment(_, id) {
    return calendarApi.deleteAppointment(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  }
};
